import {isEmpty, validateEmail, validatePhone, validateURL} from "../utils/util";
import {notification} from "antd";


export const validateData = async (configs, value, em) => {
    switch (configs?.name) {
        case "nominated_email": {
            if (!isEmpty(value) && !validateEmail(value)) {
                notification.error({message: `Enter a valid [${configs?.title}]`})
                return false
            }
        }
            break;
        case "nominated_email_secondary": {
            if (!isEmpty(value) && !validateEmail(value)) {
                notification.error({message: `Enter a valid [${configs?.title}]`})
                return false
            }
        }
            break;
        case "phone": {
            if (!isEmpty(value) && !validatePhone(value)) {
                notification.error({message: `Enter a valid [${configs?.title}]`})
                return false
            }
        }
            break;
        case "nominated_phone_secondary": {
            if (!isEmpty(value) && !validatePhone(value)) {
                notification.error({message: `Enter a valid [${configs?.title}]`})
                return false
            }
        }
            break;
        case "official_site_url": {
            if (!isEmpty(value) && !validateURL(value)) {
                notification.error({message: `Enter a valid [${configs?.title}]`})
                return false
            }
        }
            break;
        case 'post_sale_fee_class_id':{
            if(!value){
                notification.error({ message: 'Error! Post Sale Fee Class cannot be empty once set.' })
                return false
            }
        }
            break;
        case 'post_sale_orders_allowed':{
            if(value && !em?.data?.post_sale_fee_class_id){
                notification.success({ message: 'EM now is allowed to send Post Sale Orders' })
                notification.warn({ message: 'Post Sale Fee Class not set', description: 'Set Post Sale Fee Class from EAS Fee Information Tab', duration: 0 })
            }
        }
            break;
        case 'customs_data_fixed_fee':{
            if (!isEmpty(value) && value<0) {
                notification.error({message: `Customs data fee cannot be negative`})
                return false
            }
        }
            break;
    }
    return true;
}


